import { ORDER_NEWEST, ORDERING_TYPES } from '@common/constants/filters';
import { PRODUCTS_PER_PAGE } from '@common/constants/products';

export function toggleItem(arr, item) {
  return arr.includes(item) ? arr.filter(i => i !== item) : [...arr, item];
}

const encodeSize = size =>
  size.includes('/') ? encodeURI(size) : encodeURIComponent(size);

export function encodeSelectedFilters(filters = {}) {
  const {
    color,
    size,
    ordering,
    category,
    offerType,
    publishedOnly,
    newArrivalOnly,
  } = filters;
  const queryObject = {};

  queryObject.publishedOnly = publishedOnly || undefined;
  queryObject.newArrivalOnly = newArrivalOnly || undefined;
  queryObject.category = category || undefined;
  queryObject.offerType = offerType || undefined;
  queryObject.color =
    color && color.length ? color.map(encodeURIComponent).join(',') : undefined;
  queryObject.size =
    size && size.length ? size.map(encodeSize).join(',') : undefined;
  queryObject.ordering = ordering || undefined;

  let queryString = Object.entries(queryObject)
    .filter(([, value]) => !!value)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  if (queryString) {
    queryString = `?${queryString}`;
  }

  return [queryString, queryObject];
}

export function decodeQueryFilters(queryFilters = {}) {
  const filters = {
    colors: [],
    ordering: ORDER_NEWEST,
    sizes: [],
  };

  if (queryFilters.color) {
    filters.colors = queryFilters.color.split(',').map(decodeURIComponent);
  }

  if (queryFilters.size) {
    filters.sizes = queryFilters.size.split(',').map(decodeURIComponent);
  }

  if (queryFilters.ordering) {
    filters.ordering = !ORDERING_TYPES.includes(queryFilters.ordering)
      ? ORDER_NEWEST
      : queryFilters.ordering;
  }

  return filters;
}

const INVALID_SEARCH_PARAMS_VALUES = [undefined, null];

export function prepareProductsRequestParams(
  queryFilters = {},
  customFilters = {},
  maxPage,
) {
  const requestParams = {
    ...customFilters,
  };

  requestParams.page = maxPage || parseInt(queryFilters.page, 10) || 1;

  requestParams.color = queryFilters.color;

  requestParams.size = queryFilters.size;

  requestParams.ordering = ORDERING_TYPES.includes(queryFilters.ordering)
    ? queryFilters.ordering
    : undefined;

  Object.keys(requestParams).forEach(param => {
    if (INVALID_SEARCH_PARAMS_VALUES.includes(requestParams[param])) {
      delete requestParams[param];
    }
  });

  return requestParams;
}

export function getProductsMaxPage(prefetchProducts, page) {
  const productsCount = prefetchProducts.data.count;
  const numberOfPages = Math.ceil(productsCount / PRODUCTS_PER_PAGE);

  return Math.max(Math.min(page, numberOfPages), 1);
}
